import { render, staticRenderFns } from "./wsSwitch.vue?vue&type=template&id=833c9912&scoped=true&"
import script from "./wsSwitch.vue?vue&type=script&lang=js&"
export * from "./wsSwitch.vue?vue&type=script&lang=js&"
import style0 from "./wsSwitch.vue?vue&type=style&index=0&id=833c9912&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "833c9912",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VIcon,VSwitch})
